import { AxiosRequestConfig } from 'axios'
import httpClient from '@/services/httpClient'
import { IUser } from '../Auth/auth-types'
import { DependentResponse, Patient } from './types/en-us'
import GetIsMinorDependent from './mappers/GetIsMinorDependent'
import SendDependentDataActivation from './mappers/SendDependentDataActivation'
import SendPatientDataActivation from './mappers/SendPatientDataActivation'

export const activatePatient = async (
  patientData: Patient,
  config?: AxiosRequestConfig,
) => {
  const { data } = await httpClient.post(
    `/primeiro-acesso/ativar-paciente`,
    SendPatientDataActivation.toPersistence(patientData),
    {
      ...config,
      headers: {
        token: patientData?.token,
      },
    },
  )
  return data
}

export const updateDependentData = async (
  dependentData: Patient,
  config?: AxiosRequestConfig,
): Promise<DependentResponse> => {
  const holder = JSON.parse(sessionStorage.getItem('patient'))
  const token = holder?.state?.holder?.token

  const { data } = await httpClient.post(
    `/primeiro-acesso/dependentes/atualizar`,
    SendDependentDataActivation.toPersistence(dependentData),
    {
      ...config,
      headers: {
        token: token,
      },
    },
  )
  return GetIsMinorDependent.toDomain(data.object)
}

export const getAllUsers = async (token: string): Promise<IUser[]> => {
  const authType = JSON.parse(
    sessionStorage.getItem('@ConexaPaciente:authType'),
  )

  const path = `/integration/app-paciente/usuario/login/perfis-paciente?audience=WEB${
    authType === 'CPF' ? `&loginPorCpf=true` : ''
  }`

  const { data } = await httpClient.get(path, {
    headers: {
      token: token,
    },
  })

  return data.object
}
